import { render, staticRenderFns } from "./DetailVideoView.vue?vue&type=template&id=cf6086b6&scoped=true"
import script from "./DetailVideoView.vue?vue&type=script&lang=js"
export * from "./DetailVideoView.vue?vue&type=script&lang=js"
import style0 from "./DetailVideoView.vue?vue&type=style&index=0&id=cf6086b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf6086b6",
  null
  
)

export default component.exports